import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import type { Indexation } from '@features/partners/builder/settings/platform-access/indexation/indexation.component';

import { inject } from '@angular/core';
import { IndexationWebservice } from '@webservices/indexation/indexation.webservice';
import { throwError } from 'rxjs';

export const indexationResolver: ResolveFn<Indexation> = (route: ActivatedRouteSnapshot) => {
  const indexationWebservice = inject(IndexationWebservice);
  const partnerId = route.paramMap.get('partnerId');

  if (!partnerId) {
    return throwError(() => new Error('Missing route parameter: partnerId'));
  }

  return indexationWebservice.get(partnerId);
};
